import React from "react";

const Currency = ({ value }) => {
  const currencyFormat = (x) => {
    let formattedInt = new Intl.NumberFormat("en-GP", {
      style: "currency",
      currency: "GBP",
    }).format(x / 100);
    return formattedInt;
  };

  return <>{currencyFormat(value)}</>;
};

export default Currency;
